import React from 'react';

const StoreLogos = ({ language }) => {
  const stores = [
    {
      name: 'Amazon',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg',
      url: 'https://www.amazon.com',
      bg: '#FF9900'
    },
    {
      name: 'Nike',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/a/a6/Logo_NIKE.svg',
      url: 'https://www.nike.com',
      bg: '#111111'
    },
    {
      name: 'Adidas',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/2/20/Adidas_Logo.svg',
      url: 'https://www.adidas.com',
      bg: '#000000'
    },
    {
      name: 'Zara',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/f/fd/Zara_Logo.svg',
      url: 'https://www.zara.com',
      bg: '#000000'
    },
    {
      name: 'SHEIN',
      url: 'https://www.shein.com',
      bg: '#000000',
      text: 'SHEIN'
    },
    {
      name: 'Fashion Nova',
      url: 'https://www.fashionnova.com',
      bg: '#000000',
      text: 'FASHION NOVA'
    }
  ];

  return (
    <section className="py-20 px-4 bg-[#f7f5f2]">
      <div className="container mx-auto">
        <h2 className="text-4xl md:text-5xl font-bold text-center text-[#1e1919] mb-4">
          {language === 'en' ? 'Stores We Work With' : 'Tiendas con las que Trabajamos'}
        </h2>
        <p className="text-center text-[#736c64] text-lg mb-12">
          {language === 'en' 
            ? 'And many more top USA online retailers!' 
            : '¡Y muchas más tiendas en línea de EE.UU.!'}
        </p>
        
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 max-w-7xl mx-auto">
          {stores.map((store, index) => (
            <a
              key={index}
              href={store.url}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white rounded-lg p-6 flex items-center justify-center hover:shadow-xl transition-all transform hover:scale-105 border-2 border-transparent hover:border-[#8b1538]/20 min-h-[120px]"
            >
              {store.logo ? (
                <img 
                  src={store.logo} 
                  alt={store.name}
                  className="max-w-full max-h-16 object-contain"
                  style={{ filter: store.name === 'Amazon' ? 'none' : 'brightness(0)' }}
                />
              ) : (
                <span className="font-bold text-lg text-center" style={{ color: store.bg === '#000000' ? '#1e1919' : store.bg }}>
                  {store.text}
                </span>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StoreLogos;
